<template>
    <div>
        <button class="ebook-btn" :class="{open: isOpen}" @click="isOpen = !isOpen">
            <div class="ml-4">
              <div class="font-medium font-weight-bold">
                EBook Available
              </div>
              <div class="mt-2">
                <span v-if="isbn">ISBN {{ isbn }}<br></span>
              </div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </button>
          <div v-if="isOpen" class="pb-2" style="borderBottom: 1px solid #d8d8d8">
            <a v-for="link in eBookList" :key="link" target="_blank" :href="eBookLinks[link]" class="sqr-btn ma-2 font-medium">{{ link }}<v-icon>mdi-open-in-new</v-icon></a>
</div>
    </div>
</template>

<script>
export default {
  name: "EBookDropdown",
  data () {
    return {
      isOpen: false
    }
  },
  props: {
    isbn: {
      type: String,
      required: true
    }
  },
  computed: {
    eBookLinks () {
      return {
        'Amazon': `https://www.amazon.com/s/ref=nb_sb_noss?url=search-alias%3Ddigital-text&field-keywords=${this.isbn}&linkCode=ur2&tag=bakerbookhouse`,
        'Barnes & Noble': 'http://bn.com/w/?ean=' + this.isbn,
        'Vital Source': `https://www.vitalsource.com/products/?term=${this.isbn}`,
        'Red Shelf': `https://www.redshelf.com/app/ecom/search?terms=${this.isbn}`
      }
    },
    eBookList () {
      return Object.keys(this.eBookLinks)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
  .ebook-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $light-grey;
  border-top: 1px solid $light-grey;
  padding: 16px 0;
  transition: background-color 200ms ease-in-out;

  &:hover,
  &:focus {
    background-color: $light-grey;
  }

  .v-icon {
    transition: transform 300ms ease-in-out;
  }

  &.open {
    border-bottom: unset;
    .v-icon {
      transform: rotate(90deg);
    }
  }
}

.sqr-btn {
  background-color: $even-lighter-grey;
  border: 1px solid $dark-grey;
  transition: background-color 200ms ease-in-out;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  gap: 16px;
  border-radius: 5px;
  text-decoration: none;
  color: inherit;
  ::v-deep(path) {
    fill: $charcoal-grey;
  }

  &:hover {
    background-color: $grey;
  }

}
</style>
